import { app } from "./flamelink";

export const get = async () => {
  const terms = await app.content.get({
    schemaKey: "terms",
    fields: ["title", "terms"]
  });

  return terms;
};
